export default __webpack_public_path__ + "static/media/marketing.6e273d65.jpg";